module.exports = __webpack_public_path__ + "static/media/pc_icon_add_patient.ce4d65f0.svg";